var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row row__align-center"},[_c('div',{staticClass:"burger row row__full row__justify-end"},[_c('div',{staticClass:"burger__button"},[_c('BurgerButton')],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }